import React from 'react'
import PropTypes from 'prop-types'
import { ErrorViewer } from '@/components/errorViewer'

class DataLoader extends React.Component {
  static propTypes = {
    dataSource: PropTypes.func.isRequired,
    render: PropTypes.func,
    children: PropTypes.any,
    onStateUpdate: PropTypes.func,
    /**
     * in-memory filter function
     */
    filter: PropTypes.func,
    /**
     * Data used to filter data.
     * If filter property is set, this it is passed to the function as second parameter.
     * This value is also passed as first parameter on dataSource function.
     */
    filterData: PropTypes.any,
    /**
     * Optional function for data transformation. The function expects data from the server and returns transformed version.
     */
    transform: PropTypes.func
  }

  state = {
    loading: true,
    data: [],
    error: null
  }

  componentDidMount () {
    this.loadData()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.filterData !== this.props.filterData) {
      this.loadData()
    }
  }

  loadData = () => {
    const { dataSource, filter, filterData, transform } = this.props
    new Promise((resolve, reject) => {
      this._reject = reject
      this.setState({ loading: true, error: null })
      dataSource(filterData).then(data => {
        if (data && data.success === false) {
          reject(data)
        } else {
          if (filter) {
            data = data ? filter(data, filterData) : []
          }
          if (transform) {
            data = transform(data)
          }
          resolve(data)
        }
      }).catch(reject)
    }).then(data => {
      this.setState({ loading: false, data })
    }).catch(error => {
      if (!this._unmounting) {
        this.setState({ loading: false, error })
      }
    })
  }

  componentWillUnmount () {
    this._unmounting = true
    this._reject({ canceled: true })
  }

  render () {
    const { render, children, onStateUpdate } = this.props
    const { loading, data, error } = this.state
    if (onStateUpdate) onStateUpdate({ data, loading })
    if (error) return <ErrorViewer error={error} onClick={this.loadData} />
    if (children) return <React.Fragment>{children}</React.Fragment>
    return render({ data, loading }) || null
  }
}

export {
  DataLoader
}



// WEBPACK FOOTER //
// ./src/components/dataLoader.js